import { Component, OnInit, Input, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalController } from '@ionic/angular';
import { InfozonemodalComponent } from '../../components/infozonemodal/infozonemodal.component'

@Component({
    selector: 'app-infozonebutton',
    templateUrl: './infozonebutton.component.html',
    styleUrls: ['./infozonebutton.component.scss'],
    standalone: false
})
export class InfozonebuttonComponent implements OnInit {
  @Input() infozone: any;

  private api = inject(ApiService);

  constructor(public modalController:ModalController, public data: DataService) { }

  ngOnInit() {}

  async select(){
    let that = this
    const modal = await this.modalController.create({
      component: InfozonemodalComponent,
      animated: false,
      htmlAttributes: { 'aria-label': 'Info: ' + (that.infozone?.title || '') },
      componentProps: {
        infozone: that.infozone,
        basepath: that.api.getMediaBase()
      }
    });
    return await modal.present();
  }

  get thumbpath(){
    return encodeURI(this.api.mediaUrl(this.infozone.thumb));
  }
  
}